var _excluded = ["invert", "invertSmallHeader", "hiddenNav"],
    _excluded2 = ["component", "hiddenLink", "invert"],
    _excluded3 = ["variation", "config", "showMenu", "logoLink", "enableSearch", "hidePhoneNumber", "isCorporate", "invert", "withAbsoluteLinks", "absoluteBaseUrl"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React, { useState, useContext } from "react";
import styled, { ThemeContext, css } from "styled-components";
import { p } from "@nib/layout";
import { focusOutlineColor, focusOutlineStyle, focusOutlineWidth, focusOutlineOffset, colorBrandBase, colorBrandLight, colorLightest, colorWhite, colorDarkest } from "@nib-components/theme";
import { MenuSystemIcon, SearchSystemIcon, PhoneSystemIcon } from "@nib/icons";
import Link from "@nib-components/link";
import Logo from "@nib-components/logo";
import Drawer from "@nib/drawer";
import { validVariationValues, SEARCH_URL } from "../shared";
import variantConfig from "../config"; // eslint-disable-next-line @typescript-eslint/no-unused-vars

export var SmallHeaderWrapper = styled(function (_ref) {
  var invert = _ref.invert,
      invertSmallHeader = _ref.invertSmallHeader,
      hiddenNav = _ref.hiddenNav,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("header", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n\n  ", "\n"])), function (_ref2) {
  var hiddenNav = _ref2.hiddenNav;
  return hiddenNav ? "center" : "space-between";
}, function (_ref3) {
  var invert = _ref3.invert;
  return invert ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), colorBrandBase) : css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          background-color: ", ";\n          border-bottom: 1px solid ", ";\n        "])), colorWhite, colorLightest);
});
export var LogoLink = styled(Link).attrs({
  underline: false
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  && {\n    ", ";\n  }\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: -", ";\n  }\n"])), p(4), focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
var HeaderLinks = styled.nav(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n"]))); // eslint-disable-next-line jsx-a11y/anchor-has-content, @typescript-eslint/no-unused-vars

var HeaderLink = styled(function (_ref4) {
  var Component = _ref4.component,
      hiddenLink = _ref4.hiddenLink,
      invert = _ref4.invert,
      rest = _objectWithoutProperties(_ref4, _excluded2);

  return Component ? /*#__PURE__*/React.createElement(Component, rest) : /*#__PURE__*/React.createElement("a", rest);
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: ", ";\n  flex-direction: row;\n  align-items: center;\n  ", ";\n  border: none;\n  border-left-width: 1px;\n  border-left-style: solid;\n  background: transparent;\n\n  ", "\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: -", ";\n    z-index: 1;\n  }\n"])), function (_ref5) {
  var hiddenLink = _ref5.hiddenLink;
  return hiddenLink ? "none" : "flex";
}, p(4), function (_ref6) {
  var theme = _ref6.theme,
      invert = _ref6.invert;
  return invert ? css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          border-left-color: ", ";\n          color: ", ";\n        "])), theme.id === "nib" ? "#436e60" : "hsla(0, 0%, 0%, 0.2)", theme.id === "nib" ? colorBrandLight : colorWhite) : css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          border-left-color: ", ";\n          color: ", ";\n        "])), colorLightest, colorBrandBase);
}, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
HeaderLink.displayName = "HeaderLink";
var MenuLink = styled(HeaderLink)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref7) {
  var invert = _ref7.invert;
  return invert ? css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), colorWhite) : css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), colorDarkest);
});
MenuLink.displayName = "MenuLink";
export var SmallHeader = function SmallHeader(props) {
  var _props$variation = props.variation,
      variation = _props$variation === void 0 ? "arhi" : _props$variation,
      config = props.config,
      showMenu = props.showMenu,
      logoLink = props.logoLink,
      _props$enableSearch = props.enableSearch,
      enableSearch = _props$enableSearch === void 0 ? false : _props$enableSearch,
      _props$hidePhoneNumbe = props.hidePhoneNumber,
      hidePhoneNumber = _props$hidePhoneNumbe === void 0 ? false : _props$hidePhoneNumbe,
      isCorporate = props.isCorporate,
      invert = props.invert,
      withAbsoluteLinks = props.withAbsoluteLinks,
      absoluteBaseUrl = props.absoluteBaseUrl,
      otherProps = _objectWithoutProperties(props, _excluded3);

  var dataSource = config ? config : variantConfig[variation]({
    withAbsoluteLinks: withAbsoluteLinks,
    absoluteBaseUrl: absoluteBaseUrl
  });
  var smallHeaderData = dataSource.smallHeaderConfig;
  var drawerLinks = dataSource.navLinks;
  var ribbonLinks = dataSource.ribbon;
  var drawerChildren = dataSource.drawerChildren;
  var logoHref = logoLink ? logoLink : smallHeaderData && smallHeaderData.logoUrl ? smallHeaderData.logoUrl : "/";
  var CustomLogo = dataSource === null || dataSource === void 0 ? void 0 : dataSource.logoComponent;
  var themeContext = useContext(ThemeContext);
  var logoLabel = themeContext.id === "nibLegacy" ? "nib Logo" : "".concat(themeContext.id, " Logo");
  var phoneNumberDefined = Boolean(smallHeaderData.phoneNumber);
  var defaultOrCorporatePhoneNumber = isCorporate && smallHeaderData.corporatePhoneNumber ? smallHeaderData.corporatePhoneNumber : smallHeaderData.phoneNumber;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDrawerOpen = _useState2[0],
      setIsDrawerOpen = _useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, showMenu && drawerLinks && /*#__PURE__*/React.createElement(Drawer, {
    navLinks: drawerLinks,
    ribbonLinks: ribbonLinks,
    isOpen: isDrawerOpen,
    setIsOpen: setIsDrawerOpen,
    hideQuoteButton: dataSource.hideQuoteButton,
    quoteButtonUrl: dataSource.quoteButtonUrl ? dataSource.quoteButtonUrl : undefined
  }, drawerChildren), /*#__PURE__*/React.createElement(SmallHeaderWrapper, _extends({
    id: smallHeaderData ? smallHeaderData.id : "small-header",
    hiddenNav: !showMenu,
    invert: invert
  }, otherProps), /*#__PURE__*/React.createElement(LogoLink, {
    href: logoHref,
    id: "ga-inlink-logo-homepage-mobile",
    "aria-label": logoLabel
  }, CustomLogo ? /*#__PURE__*/React.createElement(CustomLogo, {
    size: "small",
    invert: invert
  }) : /*#__PURE__*/React.createElement(Logo, {
    size: "small",
    invert: invert
  })), showMenu && /*#__PURE__*/React.createElement(HeaderLinks, {
    "aria-label": "Main mobile navigation"
  }, enableSearch && /*#__PURE__*/React.createElement(HeaderLink, {
    id: "ga-nav-search-mobile",
    href: SEARCH_URL,
    "aria-label": "Search",
    invert: invert
  }, /*#__PURE__*/React.createElement(SearchSystemIcon, {
    fill: "currentColor"
  })), phoneNumberDefined && !hidePhoneNumber && /*#__PURE__*/React.createElement(HeaderLink, {
    component: "a",
    id: "ga-nav-".concat(variation !== "arhi" ? "".concat(variation, "-") : "", "call-mobile"),
    href: "tel:".concat(defaultOrCorporatePhoneNumber && defaultOrCorporatePhoneNumber.replace(/\s+/g, "")),
    "aria-label": "Call",
    invert: invert
  }, /*#__PURE__*/React.createElement(PhoneSystemIcon, {
    fill: "currentColor"
  })), smallHeaderData.navLinks && smallHeaderData.navLinks.map(function (link) {
    var Icon = link.icon;
    return /*#__PURE__*/React.createElement(HeaderLink, {
      component: "a",
      id: "".concat(link.id, "-mobile"),
      href: link.url,
      target: link.targetBlank && "_blank",
      rel: link.targetBlank && "noopener noreferrer",
      "aria-label": link.label,
      key: "".concat(link.id, "-mobile"),
      invert: invert
    }, /*#__PURE__*/React.createElement(Icon, {
      fill: "currentColor"
    }));
  }), /*#__PURE__*/React.createElement(MenuLink, {
    component: "button",
    id: "ga-nav-menu-mobile",
    onClick: function onClick() {
      setIsDrawerOpen(true);
    },
    "aria-label": "Open menu",
    invert: invert
  }, /*#__PURE__*/React.createElement(MenuSystemIcon, {
    fill: "currentColor"
  })))));
};
SmallHeader.displayName = "SmallHeader";
SmallHeader.SmallHeaderWrapper = SmallHeaderWrapper;
SmallHeader.LogoLink = LogoLink;
SmallHeader.HeaderLinks = HeaderLinks;
SmallHeader.HeaderLink = HeaderLink;
SmallHeader.defaultProps = {
  variation: "arhi",
  showMenu: false,
  isCorporate: false,
  invert: false,
  withAbsoluteLinks: false
};